/**
 * Pure helpers for Account / offboarding session-revoke Realtime signals.
 * See public.user_session_revocation_signal + useSessionRevocationWatch.
 */

/**
 * Should this device sign out given a signal row and the local JWT session id?
 * Unknown local id → false (caller should resolve getSession first; never
 * fail-closed into sign-out on parse ambiguity).
 */
export function shouldSignOutForRevocationSignal(signal, localSessionId) {
  if (!signal || typeof signal !== 'object') return false;
  if (!localSessionId || typeof localSessionId !== 'string') return false;

  if (signal.revoke_all === true) return true;

  const revoked = signal.revoked_session_id || null;
  const except = signal.except_session_id || null;

  if (revoked && revoked === localSessionId) return true;
  if (except && except === localSessionId) return false;
  if (except && except !== localSessionId) return true;

  // Malformed (neither revoke_all, revoked match, nor except) → ignore
  return false;
}

/**
 * Keep signals created at/after the current session started (watermark).
 * Prevents an old revoke_all from killing a fresh login on catch-up SELECT.
 */
export function filterSignalsForSessionWatermark(signals, sessionStartedAtMs) {
  if (!Array.isArray(signals)) return [];
  if (!Number.isFinite(sessionStartedAtMs)) return [];
  return signals.filter((row) => {
    const raw = row?.created_at;
    if (!raw) return false;
    const t = Date.parse(raw);
    if (!Number.isFinite(t)) return false;
    return t >= sessionStartedAtMs;
  });
}

/**
 * Watermark for catch-up: JWT `iat` only (seconds → ms).
 * Do NOT use auth.users.last_sign_in_at — that is user-global and updates when
 * ANY device signs in, which breaks multi-device catch-up filtering.
 */
export function sessionStartWatermarkMs({ accessTokenIatSec } = {}) {
  if (Number.isFinite(accessTokenIatSec)) {
    return accessTokenIatSec * 1000;
  }
  return null;
}
